import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { RadarIcon, BrainIcon, ShieldCheckIcon, RocketIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const blockVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function AIEngine() {
  return <section className="w-full bg-midnight px-4 md:px-8 lg:px-16 py-20 md:py-32" data-id="element-15">
      <div className="max-w-7xl mx-auto" data-id="element-16">
        <h2 className="font-heading font-bold text-ivory uppercase text-3xl sm:text-4xl md:text-6xl lg:text-7xl tracking-tight mb-16 md:mb-24" data-id="element-17">
          THE XENOJOUEUR
          <br data-id="element-18" />
          <span className="text-cobalt" data-id="element-19">ENGINE</span>
        </h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-0" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-20">
          <motion.div className="border-2 border-ivory/20 border-t-4 border-t-crimson p-6 md:p-10" variants={blockVariants} data-id="element-21">
            <RadarIcon className="w-10 h-10 md:w-14 md:h-14 text-crimson mb-6" strokeWidth={1.5} data-id="element-22" />
            <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl mb-4 tracking-tight" data-id="element-23">
              REAL-TIME REGULATORY INTELLIGENCE
            </h3>
            <p className="font-body text-ivory/70 text-base md:text-lg leading-relaxed" data-id="element-24">
              Our AI continuously monitors regulatory changes across all target
              jurisdictions. When Malta updates its responsible gaming
              requirements or Brazil introduces new advertising restrictions,
              your content adapts automatically.
            </p>
          </motion.div>

          <motion.div className="border-2 border-ivory/20 border-t-4 border-t-cobalt p-6 md:p-10" variants={blockVariants} data-id="element-25">
            <BrainIcon className="w-10 h-10 md:w-14 md:h-14 text-cobalt mb-6" strokeWidth={1.5} data-id="element-26" />
            <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl mb-4 tracking-tight" data-id="element-27">
              CULTURALLY-AWARE ADAPTATION
            </h3>
            <p className="font-body text-ivory/70 text-base md:text-lg leading-relaxed" data-id="element-28">
              Beyond translation. Our engine understands cultural context —
              adjusting tone, imagery recommendations, promotional mechanics,
              and even UI patterns to resonate with local players.
            </p>
          </motion.div>

          <motion.div className="border-2 border-ivory/20 border-t-4 border-t-emerald p-6 md:p-10" variants={blockVariants} data-id="element-29">
            <ShieldCheckIcon className="w-10 h-10 md:w-14 md:h-14 text-emerald mb-6" strokeWidth={1.5} data-id="element-30" />
            <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl mb-4 tracking-tight" data-id="element-31">
              AUTOMATED COMPLIANCE CHECKING
            </h3>
            <p className="font-body text-ivory/70 text-base md:text-lg leading-relaxed" data-id="element-32">
              Every piece of content passes through jurisdiction-specific
              compliance rules before deployment. Bonus terms, age verification
              copy, self-exclusion messaging — all validated in real-time.
            </p>
          </motion.div>

          <motion.div className="border-2 border-ivory/20 border-t-4 border-t-saffron p-6 md:p-10" variants={blockVariants} data-id="element-33">
            <RocketIcon className="w-10 h-10 md:w-14 md:h-14 text-saffron mb-6" strokeWidth={1.5} data-id="element-34" />
            <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl mb-4 tracking-tight" data-id="element-35">
              MARKET-READY IN WEEKS
            </h3>
            <p className="font-body text-ivory/70 text-base md:text-lg leading-relaxed" data-id="element-36">
              What took months now takes weeks. Launch in new jurisdictions with
              fully compliant, culturally adapted content from day one. No
              back-and-forth with legal teams across time zones.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}